export const AppLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="172.893"
      height="42.344"
      viewBox="0 0 172.893 42.344"
    >
      <g
        id="Group_11643"
        data-name="Group 11643"
        transform="translate(-269.471 -821.083)"
        style={{ mixBlendMode: "normal", isolation: "isolate" }}
      >
        <g
          id="Group_11624"
          data-name="Group 11624"
          transform="translate(269.471 821.083)"
        >
          <g
            id="Group_11622"
            data-name="Group 11622"
            transform="translate(9.446 14.051)"
          >
            <g id="Group_11621" data-name="Group 11621">
              <path
                id="Path_39957"
                data-name="Path 39957"
                d="M349.3,943.526h1.394v13.366H349.3Z"
                transform="translate(-349.295 -943.088)"
                fill="#fff"
              />
              <path
                id="Path_39958"
                data-name="Path 39958"
                d="M438.389,939.823l9.853,10.729V940.261h1.395V954.1l-9.853-10.747v10.273h-1.395Z"
                transform="translate(-427.846 -939.823)"
                fill="#fff"
              />
              <path
                id="Path_39959"
                data-name="Path 39959"
                d="M775.164,955.7H783.4v1.189h-8.225Zm.009-12.177H783.4v1.189h-8.225Zm0,5.91h7.895v1.2h-7.895Z"
                transform="translate(-724.769 -943.088)"
                fill="#fff"
              />
              <path
                id="Path_39960"
                data-name="Path 39960"
                d="M915.493,950.115l-4.015-6.589h1.591l3.335,5.365,3.228-5.365h1.574l-4,6.643,4.1,6.724h-1.646l-3.335-5.454-3.281,5.454h-1.645Z"
                transform="translate(-844.89 -943.088)"
                fill="#fff"
              />
            </g>
          </g>
          <g
            id="Group_11623"
            data-name="Group 11623"
            transform="translate(0 0)"
          >
            <path
              id="Path_39961"
              data-name="Path 39961"
              d="M617.251,947.723a6.348,6.348,0,0,0-1.123-1.947,6,6,0,0,0-1.677-1.371,6.74,6.74,0,0,0-2.06-.739q-.48-.085-1-.128c-.348-.021-.64-.036-.888-.036h-4.31c.006.016.013.03.018.046a11.632,11.632,0,0,1,.381,1.185,19.726,19.726,0,0,1,0,10.909,11.636,11.636,0,0,1-.381,1.185c-.005.015-.013.03-.018.046h4.345c.433,0,.824-.014,1.187-.036a5.615,5.615,0,0,0,1.016-.17,6.563,6.563,0,0,0,1.954-.852,6.262,6.262,0,0,0,1.563-1.435,6.558,6.558,0,0,0,1.03-1.9,6.732,6.732,0,0,0,.377-2.309A6.918,6.918,0,0,0,617.251,947.723Zm-1.265,4.334a5.386,5.386,0,0,1-.781,1.549A5.6,5.6,0,0,1,614,954.785a4.7,4.7,0,0,1-1.556.71,4.434,4.434,0,0,1-.909.149c-.327.028-.682.035-1.066.035h-2.5a21.174,21.174,0,0,0,0-10.984h2.5c.27,0,.568.007.9.028a5.116,5.116,0,0,1,.881.114,5.41,5.41,0,0,1,1.634.661,4.658,4.658,0,0,1,1.272,1.144,5.171,5.171,0,0,1,.824,1.584,6.519,6.519,0,0,1,.291,1.982A5.78,5.78,0,0,1,615.987,952.057Z"
              transform="translate(-566.346 -929.016)"
              fill="#fff"
            />
            <path
              id="Path_39962"
              data-name="Path 39962"
              d="M308.863,850.076a19.842,19.842,0,1,1,0-15.642H310.3a21.172,21.172,0,1,0,0,15.642Z"
              transform="translate(-269.471 -821.083)"
              fill="#a6dd50"
            />
          </g>
        </g>
        <g
          id="Group_11625"
          data-name="Group 11625"
          transform="translate(361.742 835.569)"
        >
          <path
            id="Path_39963"
            data-name="Path 39963"
            d="M1053.505,956.848a5.881,5.881,0,0,1-2.363-.478,5,5,0,0,1-1.92-1.495l.973-.817a4.289,4.289,0,0,0,1.438,1.2,4.053,4.053,0,0,0,1.907.452,3.023,3.023,0,0,0,1.134-.2,2.625,2.625,0,0,0,.864-.552,2.443,2.443,0,0,0,.552-.817,2.6,2.6,0,0,0,.2-1.008,1.941,1.941,0,0,0-.178-.86,2.265,2.265,0,0,0-.473-.647,2.963,2.963,0,0,0-.7-.491q-.408-.208-.851-.382l-1.529-.591a8.085,8.085,0,0,1-1.034-.487,3.572,3.572,0,0,1-.869-.678,3.182,3.182,0,0,1-.6-.925,3.121,3.121,0,0,1-.226-1.238,2.962,2.962,0,0,1,.3-1.312,3.283,3.283,0,0,1,.8-1.051,3.89,3.89,0,0,1,1.2-.7,4.216,4.216,0,0,1,1.5-.261,4.928,4.928,0,0,1,1.929.33,5.479,5.479,0,0,1,1.451.921l-.817.938a3.9,3.9,0,0,0-1.134-.76,3.578,3.578,0,0,0-1.429-.265,2.808,2.808,0,0,0-.956.156,2.316,2.316,0,0,0-.764.452,2.169,2.169,0,0,0-.517.686,1.95,1.95,0,0,0-.187.851,1.7,1.7,0,0,0,.161.76,2.014,2.014,0,0,0,.426.578,2.854,2.854,0,0,0,.63.447,6.674,6.674,0,0,0,.773.352l1.477.591a9.463,9.463,0,0,1,1.108.521,4.251,4.251,0,0,1,.951.712,3.167,3.167,0,0,1,.665.987,3.374,3.374,0,0,1,.247,1.351,3.453,3.453,0,0,1-.317,1.473,3.7,3.7,0,0,1-.878,1.19,4.04,4.04,0,0,1-1.316.79A4.582,4.582,0,0,1,1053.505,956.848Z"
            transform="translate(-1049.222 -943.503)"
            fill="#a6dd50"
          />
          <path
            id="Path_39964"
            data-name="Path 39964"
            d="M1189.141,956.874a6.8,6.8,0,0,1-2.693-.526,6.519,6.519,0,0,1-2.124-1.434,6.732,6.732,0,0,1-1.907-4.713,6.664,6.664,0,0,1,1.942-4.722,6.861,6.861,0,0,1,2.133-1.442,6.874,6.874,0,0,1,5.23-.035,7.126,7.126,0,0,1,2.085,1.351l-.816.93a7.329,7.329,0,0,0-1.7-1.147,4.843,4.843,0,0,0-2.164-.469,5.159,5.159,0,0,0-2.176.452,5.283,5.283,0,0,0-1.69,1.208,5.447,5.447,0,0,0-1.095,1.763,5.783,5.783,0,0,0-.391,2.111,5.622,5.622,0,0,0,.4,2.116,5.529,5.529,0,0,0,1.112,1.751,5.282,5.282,0,0,0,1.7,1.2,5.21,5.21,0,0,0,2.159.443,5.025,5.025,0,0,0,2.159-.443,7.409,7.409,0,0,0,1.69-1.086l.764.912a6.842,6.842,0,0,1-2.085,1.316A6.715,6.715,0,0,1,1189.141,956.874Z"
            transform="translate(-1166.655 -943.503)"
            fill="#a6dd50"
          />
          <path
            id="Path_39965"
            data-name="Path 39965"
            d="M1347.666,944.685a4.91,4.91,0,0,0-1.659.435,5.268,5.268,0,0,0-1.694,1.208,5.571,5.571,0,0,0-1.1,1.763,5.788,5.788,0,0,0,0,4.227,5.5,5.5,0,0,0,1.1,1.742,5.25,5.25,0,0,0,1.685,1.19,5.117,5.117,0,0,0,1.668.426v1.155a6.829,6.829,0,0,1-2.12-.486,6.521,6.521,0,0,1-2.133-1.4,6.679,6.679,0,0,1-1.434-2.111,6.537,6.537,0,0,1-.526-2.628,6.436,6.436,0,0,1,.534-2.611,6.883,6.883,0,0,1,1.442-2.128,6.81,6.81,0,0,1,2.133-1.438,6.507,6.507,0,0,1,2.1-.5Zm.686,11.008a5.425,5.425,0,0,0,2-.426,5.047,5.047,0,0,0,1.686-1.173,5.272,5.272,0,0,0,1.086-1.742,5.9,5.9,0,0,0,.382-2.133,6.163,6.163,0,0,0-.382-2.194,5.31,5.31,0,0,0-1.077-1.76,4.955,4.955,0,0,0-1.677-1.173,5.516,5.516,0,0,0-2.015-.426V943.5a6.943,6.943,0,0,1,2.467.5,6.442,6.442,0,0,1,3.532,3.531,7.106,7.106,0,0,1-.008,5.3,6.614,6.614,0,0,1-1.416,2.12,6.337,6.337,0,0,1-2.116,1.394,7.036,7.036,0,0,1-2.458.5Z"
            transform="translate(-1306.873 -943.503)"
            fill="#a6dd50"
          />
          <path
            id="Path_39966"
            data-name="Path 39966"
            d="M1523.215,958.033h-1.355V945.044h4.631a7.529,7.529,0,0,1,1.212.1,3.735,3.735,0,0,1,2.589,1.724,3.948,3.948,0,0,1,.578,2.15,4.43,4.43,0,0,1-.278,1.607,4.317,4.317,0,0,1-.712,1.238,3.291,3.291,0,0,1-.986.808,2.961,2.961,0,0,1-1.108.343q.825,1.269,1.625,2.516t1.6,2.506h-1.616q-.782-1.225-1.56-2.454t-1.559-2.472v-1.155q.59,0,.938-.022a3.438,3.438,0,0,0,.756-.143,1.612,1.612,0,0,0,.621-.365,2.532,2.532,0,0,0,.486-.621,3.307,3.307,0,0,0,.321-.816,3.729,3.729,0,0,0,.118-.934,3.106,3.106,0,0,0-.347-1.534,2.46,2.46,0,0,0-.947-.96,2.742,2.742,0,0,0-.8-.273,5.064,5.064,0,0,0-.934-.083h-3.276Z"
            transform="translate(-1465.931 -944.862)"
            fill="#a6dd50"
          />
          <path
            id="Path_39967"
            data-name="Path 39967"
            d="M1662.908,956.877h8v1.156h-7.993Zm.009-11.833h7.993V946.2h-7.993Zm0,5.743h7.672v1.164h-7.672Z"
            transform="translate(-1590.288 -944.862)"
            fill="#a6dd50"
          />
        </g>
      </g>
    </svg>
  );
};

export const UserAvatar = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      width="25.272"
      height="24.92"
      viewBox="0 0 25.272 24.92"
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_5049"
            data-name="Rectangle 5049"
            width="25.272"
            height="24.92"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Group_12979" data-name="Group 12979" transform="translate(0)">
        <rect
          id="Rectangle_5047"
          data-name="Rectangle 5047"
          width="8.243"
          height="7.92"
          transform="translate(17.029 9.187)"
          fill="#7be6f1"
        />
        <rect
          id="Rectangle_5048"
          data-name="Rectangle 5048"
          width="8.243"
          height="7.92"
          transform="translate(8.785 17)"
          fill="#7be6f1"
        />
        <g id="Group_11967" data-name="Group 11967" transform="translate(0 0)">
          <g
            id="Group_11966"
            data-name="Group 11966"
            transform="translate(0 0)"
            clipPath="url(#clip-path)"
          >
            <path
              id="Path_46485"
              data-name="Path 46485"
              d="M.3,16.469,0,9.018c4.088-.163,6.784-1.553,8.243-4.252A10.111,10.111,0,0,0,9.383.272V.3L16.835,0a16.774,16.774,0,0,1-4.189,11.348C9.7,14.535,5.548,16.26.3,16.469Z"
              transform="translate(-0.001 0.004)"
              fill="#7764ff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const AppLogoWhite = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 1240.6 287"
    >
      <g>
        <g>
          <g style={{ fill: "white" }}>
            <g>
              <path class="st0" d="M64,98.2h9.4v90.6H64V98.2z" />
              <path
                class="st0"
                d="M135.5,95.2l66.8,72.7V98.2h9.4V192l-66.8-72.8v69.6h-9.4V95.2z"
              />
              <path
                class="st0"
                d="M405.5,180.7h55.8v8.1h-55.7L405.5,180.7z M405.6,98.2h55.7v8.1h-55.7V98.2z M405.6,138.2h53.5v8.1h-53.5
					V138.2z"
              />
              <path
                class="st0"
                d="M542.5,142.9l-27.2-44.7H526l22.6,36.4l21.9-36.4h10.7l-27.1,45l27.8,45.6h-11.2l-22.6-37l-22.2,37h-11.2
					L542.5,142.9z"
              />
            </g>
          </g>
          <g>
            <path
              fill="white"
              class="st0"
              d="M345,126.8c-1.8-5-4.4-9.4-7.6-13.2c-3.2-3.8-7-6.9-11.4-9.3s-9-4.1-14-5c-2.2-0.4-4.4-0.7-6.8-0.9
				c-2.4-0.1-4.3-0.2-6-0.2H270c0,0.1,0.1,0.2,0.1,0.3c1,2.6,1.9,5.3,2.6,8c3.4,11.7,5.2,24.2,5.2,37c0,12.8-1.8,25.2-5.2,37
				c-0.7,2.7-1.6,5.4-2.6,8c0,0.1-0.1,0.2-0.1,0.3h29.5c2.9,0,5.6-0.1,8-0.2c2.5-0.2,4.7-0.6,6.9-1.2c4.7-1.2,9.1-3.1,13.2-5.8
				s7.6-5.9,10.6-9.7c3-3.8,5.3-8.1,7-12.9c1.7-4.8,2.5-10,2.5-15.6C347.8,137.3,346.9,131.8,345,126.8z M336.4,156.1
				c-1.2,3.9-3,7.4-5.3,10.5c-2.3,3.1-5.1,5.7-8.2,8c-3.2,2.2-6.7,3.9-10.5,4.8c-1.9,0.5-4,0.9-6.2,1c-2.2,0.2-4.6,0.2-7.2,0.2h-17
				c3.2-11.8,4.9-24.4,4.9-37.2s-1.7-25.4-4.9-37.2H299c1.8,0,3.9,0.1,6.1,0.2c2.2,0.1,4.2,0.4,6,0.8c4,0.9,7.7,2.4,11.1,4.5
				s6.2,4.6,8.6,7.8s4.3,6.7,5.6,10.7c1.3,4.1,2,8.6,2,13.4C338.3,148.1,337.7,152.2,336.4,156.1z"
            />
            <path
              class="st1"
              style={{ fill: "#a6dd50" }}
              d="M267,196.5c-20.6,47.8-68.2,81.5-123.5,81.5C69.3,278,9,217.7,9,143.5S69.3,9,143.5,9
				C198.8,9,246.4,42.6,267,90.5h9.7C255.6,37.5,203.9,0,143.5,0C64.4,0,0,64.4,0,143.5S64.4,287,143.5,287
				c60.4,0,112.1-37.5,133.2-90.5L267,196.5L267,196.5z"
            />
          </g>
        </g>
        <g style={{ fill: "#a6dd50" }}>
          <path
            class="st1"
            d="M654.3,188.6c-5.7,0-11-1.1-16-3.2s-9.3-5.5-13-10.1l6.6-5.5c2.6,3.4,5.8,6.1,9.7,8.1c3.9,2,8.2,3.1,12.9,3.1
			c2.8,0,5.4-0.5,7.7-1.4s4.2-2.2,5.9-3.7s2.9-3.4,3.7-5.5s1.3-4.4,1.3-6.8c0-2.2-0.4-4.2-1.2-5.8c-0.8-1.6-1.9-3.1-3.2-4.4
			c-1.3-1.3-2.9-2.4-4.8-3.3c-1.8-0.9-3.8-1.8-5.8-2.6l-10.4-4c-2.4-0.9-4.8-2-7-3.3c-2.2-1.2-4.2-2.8-5.9-4.6
			c-1.7-1.8-3-3.9-4.1-6.3c-1-2.4-1.5-5.2-1.5-8.4c0-3.2,0.7-6.1,2-8.9s3.2-5.1,5.5-7.1s5-3.6,8.1-4.8s6.5-1.8,10.2-1.8
			c5.2,0,9.6,0.7,13.1,2.2c3.5,1.5,6.8,3.6,9.8,6.2l-5.5,6.4c-2.4-2.2-4.9-3.9-7.7-5.2c-2.8-1.2-6-1.8-9.7-1.8
			c-2.3,0-4.5,0.3-6.5,1.1c-2,0.7-3.7,1.7-5.2,3.1c-1.5,1.3-2.7,2.9-3.5,4.7c-0.8,1.8-1.3,3.7-1.3,5.8c0,2,0.4,3.7,1.1,5.2
			c0.7,1.5,1.7,2.8,2.9,3.9c1.2,1.1,2.6,2.1,4.3,3s3.4,1.7,5.2,2.4l10,4c2.6,1,5.1,2.2,7.5,3.5c2.4,1.3,4.6,2.9,6.5,4.8
			c1.9,1.9,3.4,4.1,4.5,6.7c1.1,2.6,1.7,5.6,1.7,9.1c0,3.6-0.7,6.9-2.2,10c-1.4,3.1-3.4,5.8-6,8.1s-5.5,4.1-8.9,5.4
			C661.9,188,658.2,188.6,654.3,188.6z"
          />
          <path
            class="st1"
            d="M777.7,188.8c-6.6,0-12.7-1.2-18.2-3.6c-5.6-2.4-10.4-5.6-14.4-9.7c-4-4.1-7.2-8.9-9.5-14.4
			s-3.5-11.4-3.5-17.5c0-6.2,1.2-12.1,3.5-17.6s5.5-10.3,9.7-14.4c4.1-4.1,8.9-7.4,14.5-9.8c5.5-2.4,11.5-3.6,18-3.6
			c6.4,0,12.2,1.1,17.5,3.4s10,5.3,14.1,9.2l-5.5,6.3c-3.4-3.1-7.2-5.7-11.5-7.8c-4.3-2.1-9.2-3.2-14.7-3.2c-5.4,0-10.3,1-14.8,3.1
			s-8.3,4.8-11.5,8.2c-3.2,3.4-5.7,7.4-7.4,12c-1.8,4.6-2.7,9.3-2.7,14.3c0,5.1,0.9,9.8,2.7,14.3c1.8,4.5,4.3,8.4,7.5,11.9
			c3.2,3.4,7.1,6.1,11.5,8.1c4.5,2,9.3,3,14.6,3c5.5,0,10.4-1,14.6-3s8.1-4.4,11.5-7.4l5.2,6.2c-4.2,3.9-8.9,6.8-14.1,8.9
			C789.6,187.7,783.9,188.8,777.7,188.8z"
          />
          <path
            class="st1"
            d="M901.8,106.2c-4,0.3-7.8,1.3-11.2,2.9c-4.5,2-8.3,4.8-11.5,8.2c-3.2,3.4-5.7,7.4-7.5,11.9
			c-1.8,4.6-2.7,9.3-2.7,14.3c0,5.1,0.9,9.8,2.7,14.3c1.8,4.5,4.3,8.4,7.5,11.8c3.2,3.4,7,6.1,11.4,8.1c3.5,1.6,7.3,2.5,11.3,2.9
			v7.8c-5.1-0.4-9.8-1.4-14.4-3.3c-5.5-2.3-10.3-5.4-14.5-9.5c-4.1-4.1-7.3-8.8-9.7-14.3c-2.4-5.5-3.6-11.4-3.6-17.8
			c0-6.3,1.2-12.2,3.6-17.7c2.4-5.5,5.7-10.3,9.8-14.4c4.1-4.1,8.9-7.3,14.5-9.8c4.5-1.9,9.3-3.1,14.2-3.4L901.8,106.2L901.8,106.2z
			 M906.4,180.8c4.9-0.2,9.5-1.1,13.5-2.9c4.4-1.9,8.2-4.6,11.4-7.9c3.2-3.4,5.6-7.3,7.4-11.8c1.7-4.5,2.6-9.3,2.6-14.4
			c0-5.3-0.9-10.3-2.6-14.9c-1.7-4.6-4.2-8.6-7.3-11.9c-3.1-3.4-6.9-6-11.4-7.9c-4.1-1.8-8.7-2.7-13.7-2.9v-7.9
			c6,0.2,11.5,1.3,16.7,3.4c5.5,2.3,10.3,5.5,14.4,9.6c4.1,4.1,7.2,8.8,9.5,14.4c2.3,5.5,3.5,11.5,3.5,17.9c0,6.5-1.2,12.5-3.5,18.1
			c-2.3,5.5-5.5,10.3-9.6,14.4s-8.8,7.2-14.3,9.4c-5.2,2.1-10.7,3.2-16.7,3.4V180.8z"
          />
          <path
            class="st1"
            d="M1013.5,187.4h-9.2v-88h31.4c2.8,0,5.6,0.2,8.2,0.7s5.1,1.2,7.3,2.3c4.2,2.1,7.6,5.2,10.2,9.3s3.9,9,3.9,14.6
			c0,4-0.6,7.6-1.9,10.9c-1.3,3.3-2.9,6.1-4.8,8.4c-2,2.3-4.2,4.2-6.7,5.5c-2.5,1.3-5,2.1-7.5,2.3c3.7,5.7,7.4,11.4,11,17.1
			c3.6,5.6,7.2,11.3,10.8,17h-10.9c-3.5-5.5-7.1-11.1-10.6-16.6c-3.5-5.6-7-11.1-10.6-16.8v-7.8c2.7,0,4.8-0.1,6.4-0.1
			c1.6-0.1,3.3-0.4,5.1-1c1.5-0.5,2.9-1.3,4.2-2.5c1.3-1.2,2.4-2.6,3.3-4.2c0.9-1.6,1.7-3.5,2.2-5.5s0.8-4.2,0.8-6.3
			c0-4.1-0.8-7.6-2.3-10.4s-3.7-5-6.4-6.5c-1.6-0.9-3.4-1.5-5.4-1.8c-2-0.4-4.1-0.6-6.3-0.6h-22.2L1013.5,187.4L1013.5,187.4z"
          />
          <path
            class="st1"
            d="M1117.4,179.6h54.2v7.8h-54.2L1117.4,179.6z M1117.5,99.4h54.2v7.8h-54.2V99.4z M1117.5,138.3h52v7.9h-52
			V138.3z"
          />
        </g>
      </g>
      <g style={{ fill: "white" }}>
        <path
          class="st0"
          d="M1205.7,74.9c0-3.1,0.8-6,2.3-8.7c1.6-2.7,3.7-4.8,6.4-6.4c2.7-1.6,5.6-2.3,8.8-2.3c3.1,0,6,0.8,8.7,2.3
		s4.8,3.7,6.4,6.4c1.6,2.7,2.3,5.6,2.3,8.8c0,3.1-0.8,5.9-2.2,8.6s-3.6,4.8-6.3,6.4s-5.7,2.4-8.9,2.4c-3.2,0-6.2-0.8-8.9-2.4
		c-2.7-1.6-4.8-3.8-6.3-6.4S1205.7,77.9,1205.7,74.9z M1207.8,74.9c0,2.8,0.7,5.3,2.1,7.7c1.4,2.3,3.2,4.2,5.6,5.6s4.9,2.1,7.7,2.1
		s5.3-0.7,7.7-2.1s4.2-3.2,5.6-5.6s2.1-4.9,2.1-7.7c0-2.7-0.7-5.2-2-7.6s-3.2-4.2-5.6-5.7s-5-2.1-7.8-2.1c-2.7,0-5.3,0.7-7.6,2.1
		c-2.4,1.4-4.2,3.3-5.6,5.6C1208.5,69.6,1207.8,72.2,1207.8,74.9z M1229.4,70.5c0,1.2-0.3,2.3-0.9,3.2c-0.6,0.9-1.4,1.7-2.6,2.2
		l5.5,9.1h-2.8l-4.9-8.4h-3.9v8.4h-2.3V64.6h4.9c2.2,0,3.9,0.5,5.2,1.4C1228.8,67.1,1229.4,68.5,1229.4,70.5z M1219.8,74.9h2.6
		c1.4,0,2.5-0.4,3.3-1.1c0.8-0.7,1.2-1.8,1.2-3.2c0-2.7-1.5-4-4.6-4h-2.6L1219.8,74.9L1219.8,74.9z"
        />
      </g>
    </svg>
  );
};

export const JavascirptLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2500"
      height="2500"
      viewBox="0 0 1052 1052"
    >
      <path fill="#f0db4f" d="M0 0h1052v1052H0z" />
      <path
        d="M965.9 801.1c-7.7-48-39-88.3-131.7-125.9-32.2-14.8-68.1-25.399-78.8-49.8-3.8-14.2-4.3-22.2-1.9-30.8 6.9-27.9 40.2-36.6 66.6-28.6 17 5.7 33.1 18.801 42.8 39.7 45.4-29.399 45.3-29.2 77-49.399-11.6-18-17.8-26.301-25.4-34-27.3-30.5-64.5-46.2-124-45-10.3 1.3-20.699 2.699-31 4-29.699 7.5-58 23.1-74.6 44-49.8 56.5-35.6 155.399 25 196.1 59.7 44.8 147.4 55 158.6 96.9 10.9 51.3-37.699 67.899-86 62-35.6-7.4-55.399-25.5-76.8-58.4-39.399 22.8-39.399 22.8-79.899 46.1 9.6 21 19.699 30.5 35.8 48.7 76.2 77.3 266.899 73.5 301.1-43.5 1.399-4.001 10.6-30.801 3.199-72.101zm-394-317.6h-98.4c0 85-.399 169.4-.399 254.4 0 54.1 2.8 103.7-6 118.9-14.4 29.899-51.7 26.2-68.7 20.399-17.3-8.5-26.1-20.6-36.3-37.699-2.8-4.9-4.9-8.7-5.601-9-26.699 16.3-53.3 32.699-80 49 13.301 27.3 32.9 51 58 66.399 37.5 22.5 87.9 29.4 140.601 17.3 34.3-10 63.899-30.699 79.399-62.199 22.4-41.3 17.6-91.3 17.4-146.6.5-90.2 0-180.4 0-270.9z"
        fill="#323330"
      />
    </svg>
  );
};

export const PythonLogo = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 640 640">
      {" "}
      <defs>
        {" "}
        <filter
          id="b"
          x="-.026897"
          y="-.027037"
          width="1.0771"
          height="1.0775"
          color-interpolation-filters="sRGB"
        >
          {" "}
          <feFlood
            flood-color="rgb(0,0,0)"
            flood-opacity=".49804"
            in="SourceGraphic"
            result="flood"
          />{" "}
          <feGaussianBlur
            in="SourceGraphic"
            result="blur"
            stdDeviation="3.000000"
          />{" "}
          <feOffset dx="6.000000" dy="6.000000" in="blur" result="offset" />{" "}
          <feComposite in="flood" in2="offset" operator="in" result="comp1" />{" "}
          <feComposite
            in="SourceGraphic"
            in2="comp1"
            result="fbSourceGraphic"
          />{" "}
          <feColorMatrix
            in="fbSourceGraphic"
            result="fbSourceGraphicAlpha"
            values="0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
          />{" "}
          <feFlood
            flood-color="rgb(0,0,0)"
            flood-opacity=".49804"
            in="fbSourceGraphic"
            result="flood"
          />{" "}
          <feGaussianBlur
            in="fbSourceGraphic"
            result="blur"
            stdDeviation="3.500000"
          />{" "}
          <feOffset dx="7.500000" dy="7.500000" in="blur" result="offset" />{" "}
          <feComposite in="flood" in2="offset" operator="in" result="comp1" />{" "}
          <feComposite in="fbSourceGraphic" in2="comp1" result="comp2" />{" "}
        </filter>{" "}
        <clipPath id="d">
          {" "}
          <path
            transform="translate(-630.44 -118.47)"
            d="m0 720h1280v-720h-1280z"
          />{" "}
        </clipPath>{" "}
        <clipPath id="c">
          {" "}
          <path
            transform="translate(-649.56 -59.842)"
            d="m0 720h1280v-720h-1280z"
          />{" "}
        </clipPath>{" "}
        <linearGradient
          id="a"
          x1="318.65"
          x2="318.65"
          y1="1.2008"
          y2="637.87"
          gradientUnits="userSpaceOnUse"
        >
          {" "}
          <stop stop-color="#1e3f5c" offset="0" />{" "}
          <stop stop-color="#214768" offset=".25" />{" "}
          <stop stop-color="#244e71" offset=".5" />{" "}
          <stop stop-color="#28567c" offset=".75" />{" "}
          <stop stop-color="#2a5981" offset="1" />{" "}
        </linearGradient>{" "}
      </defs>{" "}
      <g>
        {" "}
        <circle
          cx="320"
          cy="320"
          r="319.23"
          fill="url(#a)"
        />{" "}
        <g transform="matrix(.8861 0 0 .89039 -525.6 -318.14)" filter="url(#b)">
          {" "}
          <path
            transform="matrix(8.3245 0 0 -8.3245 867.98 465.94)"
            d="m0 0c1.679 0 3.037-1.357 3.037-3.036 0-1.68-1.358-3.037-3.037-3.037-1.68 0-3.037 1.357-3.037 3.037 0 1.679 1.357 3.036 3.037 3.036m9.307 5.344c-17.688 0-16.583-7.671-16.583-7.671l0.02-7.946h16.879v-2.386h-23.584s-11.318 1.283-11.318-16.564c0-17.846 9.879-17.214 9.879-17.214h5.896v8.282s-0.318 9.879 9.721 9.879h16.741s9.406-0.152 9.406 9.09v15.282s1.428 9.248-17.057 9.248"
            clip-path="url(#d)"
            fill="#4584b6"
          />{" "}
          <path
            transform="matrix(8.3245 0 0 -8.3245 1027.1 953.96)"
            d="m0 0c-1.68 0-3.037 1.357-3.037 3.036 0 1.68 1.357 3.037 3.037 3.037 1.679 0 3.036-1.357 3.036-3.037 0-1.679-1.357-3.036-3.036-3.036m-9.308-5.344c17.688 0 16.583 7.67 16.583 7.67l-0.019 7.947h-16.879v2.386h23.583s11.318-1.284 11.318 16.564c0 17.846-9.879 17.214-9.879 17.214h-5.895v-8.282s0.318-9.879-9.721-9.879h-16.741s-9.406 0.152-9.406-9.09v-15.282s-1.428-9.248 17.056-9.248"
            clip-path="url(#c)"
            fill="#ffde57"
          />{" "}
        </g>{" "}
        <circle cx="243.15" cy="119.77" r="22.514" fill="#fff" />{" "}
        <circle cx="384.54" cy="508.82" r="22.514" fill="#fff" />{" "}
      </g>{" "}
    </svg>
  );
};

export const CSharpLogo = () => {
  return (
    <svg
      height="2500"
      preserveAspectRatio="xMidYMid"
      viewBox="0 -1.428 255.582 290.108"
      width="2222"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m255.569 84.452c-.002-4.83-1.035-9.098-3.124-12.76-2.052-3.603-5.125-6.622-9.247-9.009-34.025-19.619-68.083-39.178-102.097-58.817-9.17-5.294-18.061-5.1-27.163.27-13.543 7.986-81.348 46.833-101.553 58.536-8.321 4.818-12.37 12.19-12.372 21.771-.013 39.455 0 78.91-.013 118.365 0 4.724.991 8.91 2.988 12.517 2.053 3.711 5.169 6.813 9.386 9.254 20.206 11.703 88.02 50.547 101.56 58.536 9.106 5.373 17.997 5.565 27.17.27 34.015-19.64 68.075-39.199 102.105-58.818 4.217-2.44 7.333-5.544 9.386-9.252 1.994-3.608 2.987-7.793 2.987-12.518 0 0 0-78.889-.013-118.345"
        fill="#a179dc"
      />
      <path
        d="m128.182 143.241-125.194 72.084c2.053 3.711 5.169 6.813 9.386 9.254 20.206 11.703 88.02 50.547 101.56 58.536 9.106 5.373 17.997 5.565 27.17.27 34.015-19.64 68.075-39.199 102.105-58.818 4.217-2.44 7.333-5.544 9.386-9.252z"
        fill="#280068"
      />
      <path
        d="m255.569 84.452c-.002-4.83-1.035-9.098-3.124-12.76l-124.263 71.55 124.413 72.073c1.994-3.608 2.985-7.793 2.987-12.518 0 0 0-78.889-.013-118.345"
        fill="#390091"
      />
      <g fill="#fff">
        <path d="m201.892 116.294v13.474h13.474v-13.474h6.737v13.474h13.474v6.737h-13.474v13.473h13.474v6.737h-13.474v13.474h-6.737v-13.474h-13.474v13.474h-6.737v-13.474h-13.473v-6.737h13.473v-13.473h-13.473v-6.737h13.473v-13.474zm13.474 20.21h-13.474v13.474h13.474z" />
        <path d="m128.457 48.626c35.144 0 65.827 19.086 82.262 47.456l-.16-.273-41.35 23.808c-8.146-13.793-23.08-23.102-40.213-23.294l-.54-.003c-26.125 0-47.305 21.18-47.305 47.305a47.08 47.08 0 0 0 6.239 23.47c8.154 14.235 23.483 23.836 41.067 23.836 17.693 0 33.109-9.723 41.221-24.11l-.197.345 41.287 23.918c-16.255 28.13-46.518 47.157-81.253 47.536l-1.058.006c-35.255 0-66.025-19.204-82.419-47.724-8.003-13.923-12.582-30.064-12.582-47.277 0-52.466 42.532-95 95-95z" />
      </g>
    </svg>
  );
};

export const CPlusLogo = () => {
  return (
    <svg
      width="2222"
      height="2500"
      viewBox="0 0 256 288"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMinYMin meet"
    >
      <path
        d="M255.569 84.72c-.002-4.83-1.035-9.098-3.124-12.761-2.052-3.602-5.125-6.621-9.247-9.008-34.025-19.619-68.083-39.178-102.097-58.817-9.17-5.294-18.061-5.101-27.163.269C100.395 12.39 32.59 51.237 12.385 62.94 4.064 67.757.015 75.129.013 84.711 0 124.166.013 163.62 0 203.076c.002 4.724.991 8.909 2.988 12.517 2.053 3.711 5.169 6.813 9.386 9.254 20.206 11.703 88.02 50.547 101.56 58.536 9.106 5.373 17.997 5.565 27.17.269 34.015-19.64 68.075-39.198 102.105-58.817 4.217-2.44 7.333-5.544 9.386-9.252 1.994-3.608 2.985-7.793 2.987-12.518 0 0 0-78.889-.013-118.345"
        fill="#5C8DBC"
      />
      <path
        d="M128.182 143.509L2.988 215.593c2.053 3.711 5.169 6.813 9.386 9.254 20.206 11.703 88.02 50.547 101.56 58.536 9.106 5.373 17.997 5.565 27.17.269 34.015-19.64 68.075-39.198 102.105-58.817 4.217-2.44 7.333-5.544 9.386-9.252l-124.413-72.074"
        fill="#1A4674"
      />
      <path
        d="M91.101 164.861c7.285 12.718 20.98 21.296 36.69 21.296 15.807 0 29.58-8.687 36.828-21.541l-36.437-21.107-37.081 21.352"
        fill="#1A4674"
      />
      <path
        d="M255.569 84.72c-.002-4.83-1.035-9.098-3.124-12.761l-124.263 71.55 124.413 72.074c1.994-3.608 2.985-7.793 2.987-12.518 0 0 0-78.889-.013-118.345"
        fill="#1B598E"
      />
      <path
        d="M248.728 148.661h-9.722v9.724h-9.724v-9.724h-9.721v-9.721h9.721v-9.722h9.724v9.722h9.722v9.721M213.253 148.661h-9.721v9.724h-9.722v-9.724h-9.722v-9.721h9.722v-9.722h9.722v9.722h9.721v9.721"
        fill="#FFF"
      />
      <path
        d="M164.619 164.616c-7.248 12.854-21.021 21.541-36.828 21.541-15.71 0-29.405-8.578-36.69-21.296a42.062 42.062 0 0 1-5.574-20.968c0-23.341 18.923-42.263 42.264-42.263 15.609 0 29.232 8.471 36.553 21.059l36.941-21.272c-14.683-25.346-42.096-42.398-73.494-42.398-46.876 0-84.875 38-84.875 84.874 0 15.378 4.091 29.799 11.241 42.238 14.646 25.48 42.137 42.637 73.634 42.637 31.555 0 59.089-17.226 73.714-42.781l-36.886-21.371"
        fill="#FFF"
      />
    </svg>
  );
};

export const JavaLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1344"
      height="2500"
      viewBox="6.527 4.399 290.829 540.906"
    >
      <path
        d="M285.104 430.945h-2.037v-1.14h5.486v1.14h-2.025v5.688h-1.424v-5.688zm10.942.297h-.032l-2.02 5.393h-.924l-2.006-5.393h-.024v5.393h-1.343v-6.828h1.976l1.86 4.835 1.854-4.835h1.969v6.828h-1.311l.001-5.393z"
        fill="#e76f00"
      />
      <path
        d="M102.681 291.324s-14.178 8.245 10.09 11.035c29.4 3.354 44.426 2.873 76.825-3.259 0 0 8.518 5.341 20.414 9.967-72.63 31.128-164.376-1.803-107.329-17.743M93.806 250.704s-15.902 11.771 8.384 14.283c31.406 3.24 56.208 3.505 99.125-4.759 0 0 5.937 6.018 15.271 9.309-87.815 25.678-185.624 2.025-122.78-18.833"
        fill="#5382a1"
      />
      <path
        d="M168.625 181.799c17.896 20.604-4.701 39.146-4.701 39.146s45.439-23.458 24.571-52.833c-19.491-27.395-34.438-41.005 46.479-87.934.001-.001-127.013 31.721-66.349 101.621"
        fill="#e76f00"
      />
      <path
        d="M264.684 321.369s10.492 8.646-11.555 15.333c-41.923 12.7-174.488 16.535-211.314.507-13.238-5.76 11.587-13.752 19.396-15.429 8.144-1.766 12.798-1.437 12.798-1.437-14.722-10.371-95.157 20.363-40.857 29.166 148.084 24.015 269.944-10.814 231.532-28.14M109.499 208.617s-67.431 16.016-23.879 21.832c18.389 2.462 55.047 1.905 89.192-.956 27.906-2.354 55.928-7.358 55.928-7.358s-9.84 4.214-16.959 9.074c-68.475 18.01-200.756 9.631-162.674-8.79 32.206-15.568 58.392-13.802 58.392-13.802M230.462 276.231c69.608-36.171 37.425-70.932 14.96-66.248-5.506 1.146-7.961 2.139-7.961 2.139s2.045-3.202 5.947-4.588c44.441-15.624 78.619 46.081-14.346 70.521 0 0 1.079-.962 1.4-1.824"
        fill="#5382a1"
      />
      <path
        d="M188.495 4.399s38.55 38.562-36.563 97.862c-60.233 47.567-13.735 74.689-.025 105.678-35.158-31.723-60.96-59.647-43.65-85.637 25.406-38.151 95.792-56.648 80.238-117.903"
        fill="#e76f00"
      />
      <path
        d="M116.339 374.246c66.815 4.277 169.417-2.373 171.846-33.987 0 0-4.67 11.984-55.219 21.503-57.027 10.731-127.364 9.479-169.081 2.601.002-.002 8.541 7.067 52.454 9.883"
        fill="#5382a1"
      />
      <path
        d="M105.389 495.049c-6.303 5.467-12.96 8.536-18.934 8.536-8.527 0-13.134-5.113-13.134-13.314 0-8.871 4.937-15.357 24.739-15.357h7.328l.001 20.135m17.392 19.623V453.93c0-15.518-8.85-25.756-30.188-25.756-12.457 0-23.369 3.076-32.238 6.999l2.56 10.752c6.983-2.563 16.022-4.949 24.894-4.949 12.292 0 17.58 4.949 17.58 15.181v7.678h-6.135c-29.865 0-43.337 11.593-43.337 28.993 0 15.018 8.878 23.554 25.594 23.554 10.745 0 18.766-4.437 26.264-10.929l1.361 9.221 13.645-.002zM180.824 514.672h-21.691l-26.106-84.96h18.944l16.198 52.199 3.601 15.699c8.195-22.698 13.992-45.726 16.891-67.898h18.427c-4.938 27.976-13.822 58.684-26.264 84.96M264.038 495.049c-6.315 5.467-12.983 8.536-18.958 8.536-8.512 0-13.131-5.113-13.131-13.314 0-8.871 4.947-15.357 24.748-15.357h7.341v20.135m17.39 19.623V453.93c0-15.518-8.871-25.756-30.186-25.756-12.465 0-23.381 3.076-32.246 6.999l2.557 10.752c6.985-2.563 16.041-4.949 24.906-4.949 12.283 0 17.579 4.949 17.579 15.181v7.678h-6.146c-29.873 0-43.34 11.593-43.34 28.993 0 15.018 8.871 23.554 25.584 23.554 10.752 0 18.77-4.437 26.28-10.929l1.366 9.221 13.646-.002zM36.847 529.099c-4.958 7.239-12.966 12.966-21.733 16.206L6.527 535.2c6.673-3.424 12.396-8.954 15.055-14.104 2.3-4.581 3.252-10.485 3.252-24.604v-96.995h18.478v95.666c-.001 18.875-1.51 26.5-6.465 33.936"
        fill="#e76f00"
      />
    </svg>
  );
};

export const HtmlLogo = () => {
  return (
    <svg
      fill="none"
      height="2500"
      width="2183"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 124 141.53199999999998"
    >
      <path
        d="M10.383 126.894L0 0l124 .255-10.979 126.639-50.553 14.638z"
        fill="#e34f26"
      />
      <path
        d="M62.468 129.277V12.085l51.064.17-9.106 104.851z"
        fill="#ef652a"
      />
      <path
        d="M99.49 41.362l1.446-15.49H22.383l4.34 47.49h54.213L78.81 93.617l-17.362 4.68-17.617-5.106-.936-12.085H27.319l2.128 24.681 32 8.936 32.255-8.936 4.34-48.17H41.107L39.49 41.362z"
        fill="#fff"
      />
    </svg>
  );
};
